import React from "react";
import styled from "styled-components";
import { Sparkles } from "lucide-react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { useNewLook } from "features/newLook/NewLook.context.ts";
import { TRY_NEW_LOOK_BUTTON_ID } from "testIds.ts";

const TryNewLookButton = () => {
  const { setIsNewLook } = useNewLook();
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);

  return (
    <Wrapper
      type="button"
      onClick={() => setIsNewLook(true)}
      data-testid={TRY_NEW_LOOK_BUTTON_ID}
    >
      <Sparkles size={14} strokeWidth={1.75} />
      {t("user_info.try_new_look")}
    </Wrapper>
  );
};

export default TryNewLookButton;

const Wrapper = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  margin-left: 12px;
  padding: 0 12px;
  flex: none;
  white-space: nowrap;
  border: 1px solid ${(p) => p.theme.colors.lightBorderGrey};
  border-radius: 8px;
  background: ${(p) => p.theme.colors.cardBgColor};
  color: ${(p) => p.theme.colors.primaryBlue};
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    border-color: ${(p) => p.theme.colors.primaryBlue};
  }
`;
